module.exports = __webpack_public_path__ + "31f85ae93b2da850e7f27d950242c0f8.pdf";